import React from 'react';
import { FormState } from '../../types';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
import { RadioGroup } from '../ui/RadioGroup';
import { yesNoOptions } from '../../data/mockData';
interface Props {
  state: FormState;
  onChange: (field: keyof FormState, value: any) => void;
}
export function DisclosureDetails({
  state,
  onChange
}: Props) {
  const isPurchase = state.loanPurpose === 'Purchase';
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-5" data-id="element-169">
      <Select label="Channel" value={state.channel} onChange={e => onChange('channel', e.target.value)} options={[{
      label: 'Broker',
      value: 'Broker'
    }, {
      label: 'Correspondent',
      value: 'Correspondent'
    }]} required data-id="element-170" />

      <Select label="Designated Lender" value={state.designatedLender} onChange={e => onChange('designatedLender', e.target.value)} options={[{
      label: 'UWM',
      value: 'UWM'
    }, {
      label: 'Madison Mortgage Services Inc.',
      value: 'Madison Mortgage Services Inc.'
    }]} required data-id="element-171" />

      <Select label="Lock Period" value={state.lockPeriod} onChange={e => onChange('lockPeriod', e.target.value)} options={[{
      label: '15 Days',
      value: '15 Days'
    }, {
      label: '30 Days',
      value: '30 Days'
    }, {
      label: '45 Days',
      value: '45 Days'
    }, {
      label: '60 Days',
      value: '60 Days'
    }, {
      label: 'Custom',
      value: 'Custom'
    }]} required data-id="element-172" />

      {state.lockPeriod === 'Custom' && <Input label="Custom Lock Period" value={state.customLockPeriod} onChange={e => onChange('customLockPeriod', e.target.value)} required data-id="element-173" />}

      {state.channel === 'Correspondent' ? <>
          <Input label="Origination Fee %" value={state.originationFeePercent} onChange={e => onChange('originationFeePercent', e.target.value)} required data-id="element-174" />

          <Input label="Discount Fee %" value={state.discountFeePercent} onChange={e => onChange('discountFeePercent', e.target.value)} required data-id="element-175" />
        </> : <>
          <Select label="Originator Comp Type" value={state.originatorCompType} onChange={e => onChange('originatorCompType', e.target.value)} options={[{
        label: 'Lender Paid',
        value: 'Lender Paid'
      }, {
        label: 'Borrower Paid',
        value: 'Borrower Paid'
      }]} required data-id="element-176" />

          {state.originatorCompType === 'Borrower Paid' && <Input label="Origination Fee %" value={state.originationFeePercent} onChange={e => onChange('originationFeePercent', e.target.value)} required data-id="element-177" />}
        </>}

      <Select label="Closing Type" value={state.closingType} onChange={e => onChange('closingType', e.target.value)} options={[{
      label: 'In-Person',
      value: 'In-Person'
    }, {
      label: 'Hybrid',
      value: 'Hybrid'
    }, {
      label: 'Virtual',
      value: 'Virtual'
    }]} required data-id="element-178" />

      <Select label="Loan Source" value={state.loanSource} onChange={e => onChange('loanSource', e.target.value)} options={[{
      label: 'Self-Generated',
      value: 'Self-Generated'
    }, {
      label: 'Company Generated',
      value: 'Company Generated'
    }]} required data-id="element-179" />

      <Input label="Madison ECD" type="date" value={state.madisonECD} onChange={e => onChange('madisonECD', e.target.value)} required data-id="element-180" />

      {isPurchase && <Input label="Mortgage Commitment Due" type="date" value={state.mortgageCommitmentDue} onChange={e => onChange('mortgageCommitmentDue', e.target.value)} required data-id="element-181" />}

      {/* ---- Yes/No questions ---- */}
      <RadioGroup label="Is a New Deed Required?" name="newDeedRequired" value={state.newDeedRequired} onChange={val => onChange('newDeedRequired', val)} options={yesNoOptions} inline data-id="element-182" />

      <RadioGroup label="Lock At Disclosure" name="lockAtDisclosure" value={state.lockAtDisclosure} onChange={val => onChange('lockAtDisclosure', val)} options={yesNoOptions} inline data-id="element-183" />

      <div className="md:col-span-2" data-id="element-184">
        <RadioGroup label="Will this Loan receive compensation on both the front and the back via YSP?" name="compensationFrontBackYSP" value={state.compensationFrontBackYSP} onChange={val => onChange('compensationFrontBackYSP', val)} options={yesNoOptions} inline data-id="element-185" />
      </div>

      <RadioGroup label="Waive Underwriting Fee?" name="waiveUnderwritingFee" value={state.waiveUnderwritingFee} onChange={val => onChange('waiveUnderwritingFee', val)} options={yesNoOptions} inline data-id="element-186" />

      <RadioGroup label="New Construction?" name="newConstruction" value={state.newConstruction} onChange={val => onChange('newConstruction', val)} options={yesNoOptions} inline data-id="element-187" />

      <RadioGroup label="Is there a pre-payment penalty?" name="prePaymentPenalty" value={state.prePaymentPenalty} onChange={val => onChange('prePaymentPenalty', val)} options={yesNoOptions} inline data-id="element-188" />

      {state.prePaymentPenalty === 'Yes' && <Input label="Pre-Payment penalty duration (years)" value={state.prePaymentPenaltyDuration} onChange={e => onChange('prePaymentPenaltyDuration', e.target.value)} required data-id="element-189" />}

      <RadioGroup label="Paystubs in 60 days of Disclosure Date?" name="paystubsIn60Days" value={state.paystubsIn60Days} onChange={val => onChange('paystubsIn60Days', val)} options={yesNoOptions} inline data-id="element-190" />

      <RadioGroup label="Are you utilizing future income?" name="utilizingFutureIncome" value={state.utilizingFutureIncome} onChange={val => onChange('utilizingFutureIncome', val)} options={yesNoOptions} inline data-id="element-191" />

      <RadioGroup label="Clearly Validated Offer Letter?" name="clearlyValidatedOfferLetter" value={state.clearlyValidatedOfferLetter} onChange={val => onChange('clearlyValidatedOfferLetter', val)} options={yesNoOptions} inline data-id="element-192" />

      <RadioGroup label="Are any borrowers employed by family?" name="borrowersEmployedByFamily" value={state.borrowersEmployedByFamily} onChange={val => onChange('borrowersEmployedByFamily', val)} options={yesNoOptions} inline data-id="element-193" />

      <RadioGroup label="Do we have 2 Years Tax Returns?" name="twoYearsTaxReturns" value={state.twoYearsTaxReturns} onChange={val => onChange('twoYearsTaxReturns', val)} options={yesNoOptions} inline data-id="element-194" />

      <RadioGroup label="Appraisal Waiver?" name="appraisalWaiverRequested" value={state.appraisalWaiverRequested} onChange={val => onChange('appraisalWaiverRequested', val)} options={yesNoOptions} inline data-id="element-195" />

      <RadioGroup label="Escrow Account" name="escrowAccount" value={state.escrowAccount} onChange={val => onChange('escrowAccount', val)} options={yesNoOptions} inline data-id="element-196" />

      <div className="md:col-span-2" data-id="element-197">
        <RadioGroup label="Borrower Approved Cash at Closing" name="borrowerApprovedCashAtClosing" value={state.borrowerApprovedCashAtClosing} onChange={val => onChange('borrowerApprovedCashAtClosing', val)} options={yesNoOptions} inline data-id="element-198" />
      </div>

      {isPurchase && <RadioGroup label="Is Buyer Paying Seller Transfer Tax?" name="buyerPayingSellerTransferTax" value={state.buyerPayingSellerTransferTax} onChange={val => onChange('buyerPayingSellerTransferTax', val)} options={yesNoOptions} inline data-id="element-199" />}

      {isPurchase && state.buyerPayingSellerTransferTax === 'Yes' && <Input label="Transfer Tax Amount" value={state.transferTaxAmount} onChange={e => onChange('transferTaxAmount', e.target.value)} required data-id="element-200" />}

      {isPurchase && <RadioGroup label="Is Buyer Paying Realtor Commission?" name="buyerPayingRealtorCommission" value={state.buyerPayingRealtorCommission} onChange={val => onChange('buyerPayingRealtorCommission', val)} options={yesNoOptions} inline data-id="element-201" />}

      {isPurchase && state.buyerPayingRealtorCommission === 'Yes' && <Input label="Realtor Commission" value={state.realtorCommission} onChange={e => onChange('realtorCommission', e.target.value)} required data-id="element-202" />}
    </div>;
}